import { BreakpointName } from '../../enums/BreakpointName';

export const mobileBreakpoints = [BreakpointName.ExtraSmall, BreakpointName.Small];
